import type { Color } from '@shieldpay/theme-provider-ui/theme/types';

import { Box } from '../box/box';

import * as styles from './divider.css';

export interface DividerProps {
  type?: 'horizontal' | 'vertical';
  color?: Color;
  expand?: boolean;
}

export const Divider = ({
  type = 'horizontal',
  color = 'neutral500',
  expand = false,
}: DividerProps) => (
  <Box
    className={
      type === 'horizontal' ? styles.horizontalDivider : styles.verticalDivider
    }
    expand={expand}
    variant="initial"
    background={color}
  />
);
